module.exports = __webpack_public_path__ + "static/media/code.0e553f77.svg";